import { withBreadCrumbs } from "lego-gui-lib";
import { inject } from "mobx-react";
import React from "react";
import { CreateView, IndexView, ShowView } from "lego-gui-lib/lib";
import { GroupAreaIndex } from "./areas/views";
import { EditGroupSchema } from "./schema";
import { NestedView } from "../../../common/nestedViewComponent";
import { isAllowed } from "../../../common/common";
import { customRowButtonsForNestedIndex } from "../../../common/CustomerAwareRowButtons";
import { observer } from "mobx-react-lite";
import { useHistory } from "react-router";

const injectDataSource = (comp: any) =>
  inject(
    "areaSplitting",
    "areaSplittingGroup",
    "auth",
    "language",
    "i18n"
  )(observer(comp));

const IndexSchema = EditGroupSchema;
export const AreaSplittingGroupIndex = injectDataSource((props: any) => {
  const { areaSplitting, areaSplittingGroup, i18n, auth, ...rest } = props;
  const title = i18n.t("hns:areaSplittingGroup:domain", { count: 2 });
  return (
    <IndexView
      dataSource={areaSplittingGroup.listDataSource}
      {...rest}
      title={title}
      titleButtons={props.isAllowed ? undefined : () => <></>}
      toolbarButtons={{ delete: props.isAllowed, export: false }}
      rowButtons={(indexProps: any) =>
        customRowButtonsForNestedIndex(indexProps, props.isAllowed, {
          copy: false
        })
      }
      columns={IndexSchema}
      baseUrl="/groups"
    />
  );
});

export const AreaSplittingGroupCreate = injectDataSource(
  ({ areaSplittingGroup, i18n, match, ...rest }: any) => {
    const title = i18n.t("common:create", {
      domain: "hns:areaSplittingGroup:domain"
    });
    const baseUrl = match.url;
    const history = useHistory();
    return withBreadCrumbs(
      { to: baseUrl + "/create", children: title },
      <CreateView
        dataSource={areaSplittingGroup.oneDataSource}
        {...rest}
        title={title}
        fields={EditGroupSchema}
        goBack={() => history.goBack()}
      />
    );
  }
);

export const AreaSplittingGroupEdit = injectDataSource((props: any) => {
  const {
    areaSplitting,
    areaSplittingGroup,
    match,
    auth,
    i18n,
    ...rest
  } = props;
  let title = i18n.t("hns:areaSplittingGroup:domain");
  const baseUrl = match.url;
  const history = useHistory();

  let allowed = false;

  if (areaSplitting.oneDataSource.one) {
    if (isAllowed(areaSplitting)) {
      allowed = true;
      title = i18n.t("common:edit", {
        domain: "hns:areaSplittingGroup:domain"
      });
    }
  }

  return withBreadCrumbs(
    { to: baseUrl + "/edit", children: title },
    <NestedView
      showView={
        <ShowView
          preloadData={false}
          dataSource={areaSplittingGroup.oneDataSource}
          id={match.params}
          hideDeleteButton={!allowed}
          title={title}
          goBack={() => history.goBack()}
          fields={allowed ? EditGroupSchema : EditGroupSchema.makeAllReadonly()}
          onlyView={!allowed}
        />
      }
      indexView={<GroupAreaIndex match={match} {...rest} isAllowed={allowed} />}
    />
  );
});
